import { Grid } from '@material-ui/core';
import styled from 'styled-components';

export const StyledGrid = styled(Grid)`
    && {
        height: 100%;
        display: flex;
        flex-wrap: nowrap;
    }
`;

export const StyledRCXIFrame = styled.iframe`
    border: none;
    z-index: 3;
`;
